export default function Lists({ shape }) {
  return {
    MuiList: {
      styleOverrides: {
        root: {
          m: 0
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          // color: 'inherit',
          // minWidth: 'auto',
          // marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          // minWidth: 'auto',
          // marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: shape.borderRadiusLg
          // minWidth: 'auto',
          // marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          // marginTop: 0,
          // marginBottom: 0
        },
        multiline: {
          // marginTop: 0,
          // marginBottom: 0
        }
      }
    }
  };
}
